export var DiffType;
(function(DiffType2) {
  DiffType2["ADDITION"] = "ADDITION";
  DiffType2["REMOVAL"] = "REMOVAL";
  DiffType2["CHANGE"] = "CHANGE";
})(DiffType || (DiffType = {}));
